$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p == 'organizer_product_extra_template' && a == 'list') {
    let product_extra_template_modal_lock = false;

    $(document).on('click', '#product-extra-template-new-button', function () {
      let locationId = $('body').attr('event_id');
      getProductExtraTemplateModal(locationId);
    });

    $(document).on(
      'click',
      '.product-extra-template-update-button',
      function () {
        let locationId = $('body').attr('event_id');
        let productExtraTemplateId = $(this).attr(
          'data-product-extra-template-id'
        );
        getProductExtraTemplateModal(locationId, productExtraTemplateId);
      }
    );

    function getProductExtraTemplateModal(
      locationId,
      productExtraTemplateId = null
    ) {
      if ($('#product-extra-template-registration-form-modal').length) {
        $('#product-extra-template-registration-form-modal').remove();
      }

      if (!product_extra_template_modal_lock) {
        product_extra_template_modal_lock = true;
        $.ajax({
          type: 'POST',
          url: '/ajax/organizer_product_extra_template/get_modal',
          data: {
            location_id: locationId,
            product_extra_template_id: productExtraTemplateId,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $('#content').append(data.html);
              $('#product-extra-template-registration-form-modal').modal(
                'show'
              );
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
            product_extra_template_modal_lock = false;
          })
          .always(function () {
            product_extra_template_modal_lock = false;
          });
      }
      return false;
    }
  }
});
